"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.personaOrganizationFactory = void 0;
const Factory = require("factory.ts");
const persona_1 = require("../../../../mocks/persona");
exports.personaOrganizationFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    first_name: persona_1.persona.first_name,
    last_name: persona_1.persona.last_name,
    profile_images: persona_1.persona.profile_image,
});
